import { motion } from "framer-motion";

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <motion.div
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, ease: "easeOut" }}
        className="absolute inset-0 w-full h-full"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20Nigerian%20technology%20office%20with%20digital%20network%20connections%2C%20futuristic%20blue%20and%20orange%20lighting%2C%20professional%20business%20environment%20with%20African%20professionals%20working%20on%20computers%20and%20digital%20devices%2C%20sleek%20contemporary%20workspace%20with%20tech%20infrastructure%2C%20innovation%20and%20connectivity%20theme%2C%20clean%20minimalist%20design%20with%20vibrant%20technology%20elements&width=1920&height=1080"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </motion.div>

      {/* Content */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: { staggerChildren: 0.25 },
          },
        }}
        className="relative z-10 max-w-5xl mx-auto px-6 text-center"
      >
        <motion.h1
          variants={{
            hidden: { y: 50, opacity: 0 },
            visible: { y: 0, opacity: 1 },
          }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-3xl md:text-6xl font-bold text-white mb-6 leading-tight"
        >
          Connecting People, Businesses, and Opportunities Through Innovation
        </motion.h1>

        <motion.p
          variants={{
            hidden: { y: 30, opacity: 0 },
            visible: { y: 0, opacity: 1 },
          }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed"
        >
          Empowering Nigeria with cutting-edge communication systems, robust
          digital infrastructure, and comprehensive skill-development services
          for individuals and businesses.
        </motion.p>

        <motion.div
          variants={{
            hidden: { y: 20, opacity: 0 },
            visible: { y: 0, opacity: 1 },
          }}
          transition={{ duration: 0.6 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <motion.button
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => scrollToSection("services")}
            className="bg-orange-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-600 transition-all w-full sm:w-auto"
          >
            Get Started
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => scrollToSection("agent")}
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-all w-full sm:w-auto"
          >
            Become an Agent
          </motion.button>
        </motion.div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.i
          animate={{ y: [0, 12, 0] }}
          transition={{ repeat: Infinity, duration: 1.4 }}
          className="ri-arrow-down-line text-white text-3xl"
        />
      </motion.div>
    </section>
  );
}
